import { CommonUtilities } from "../../commonUtils";
import Pagination from "../../components/Header/Pagination";
import React, { Suspense, useState, useEffect } from "react";
import TooltipList from "../Common/tooltip";
import Drawer from 'react-modern-drawer';
import DatePickerRange from "../PeriodSelection/DatePickerRange";
import { format } from "date-fns";
import UserServices from "./UserServices";

export default function MoveToTeam (projectDetails : any){

    const [setting , setSetting] = React.useState<any[]>([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const [moveData , setMoveData] = React.useState<any[]>([]);
    const toggleDrawer = () => {
        setIsOpen(!isOpen)
        projectDetails.onChange("close")
    }

    const param = {
        "allDeals": 0 ,
        "contactEnd": "",
        "contactStart": "",
        "contactType": "",
        "kontactCode": projectDetails.param.kontactCode,
        "projectContactId": 0,
        "projectId": projectDetails.param.projectId,
        "unknownDates": 0 
    }
    const startDateSelection = (e:any) => {
        param.contactStart = ((format(new Date(e), 'yyyy-MM-dd')) + 'T' + (format(new Date(e), 'hh:mm:ss.')) + '000Z' )
    }
    const endDateSelection = (e:any) => {
        param.contactEnd = ((format(new Date(e), 'yyyy-MM-dd')) + 'T' + (format(new Date(e), 'hh:mm:ss.')) + '000Z' )       
    }

    const moveTo = (e :any ) => {
        UserServices.moveToTeam(param)
    }

    return (
        <>
            <button className= "icon-btn edit pull-right btn-small mb mr"  onClick={ () => setIsOpen(true)}>
            {/*<button className={moveBtn ==true?"icon-btn edit pull-right btn-xl ws-2 full-height":"hide"} >*/}
               <i className="icon-angle-double-right "></i>
                                                                   
            </button>

         <Drawer open={isOpen}
            onClose={toggleDrawer}
            direction='right'
            className='box react-drawer allowVscroll'
            size={600}>

            <div className="box">
                <div className="box-header well">
                    <h2 >Move contacts to team</h2>
                </div>
                <div className="box-content">
                    <div className="row-fluid">
                        <form className="form-horizontal form-condensed" name="frmclassNameListing">
                            <div className="alert alert-danger hide">
                                There was a problem submitting your request, one or more fields are missing or incorrect.
                            </div>
                            <div className="alert alert-success hide"> className List Details have been saved successfully
                            </div>
                            <div className="alert alert-success hide">className List has been deleted successfully
                            </div>
                            <div className="row-fluid">
                                <div className="span6">
                                    <div className="form-format ws-6">
                                        <label > Contact Start Date</label>

                                        <div className="label-entries">
                                            <DatePickerRange type ={"single"} onChange={startDateSelection} data = {"Contact Start Date"}/>
                                        </div>
                                    </div>

                                    <div className="form-format ws-6">
                                        <label > Contact End Date</label>

                                        <div className="label-entries">
                                            <DatePickerRange type ={"single"} onChange={endDateSelection} data = {"Contact End Date"}/>                                            
                                        </div>
                                    </div>

                                    <div className="form-format ws-6 ptl">
                                        <label>Unknown Dates</label>
                                        <label className="switch">
                                            <input type="checkbox" name="unknownDates" onChange={ (e) => {moveTo(e.target.checked) ;(e.target.checked==true? param.unknownDates =1 :param.unknownDates=0 ) }}/>
                                            <span className="slider round text-left white pm pts hide" >Yes</span>
                                            <span className="slider round text-right white pm pts sliderOff">No</span></label>
                                    </div>

                                    <div className="form-format ws-6 ptl">
                                        <label>All Deals</label>
                                        <label className="switch">
                                            <input type="checkbox" name="Deals" onChange={ (e) => {moveTo(e) ;(e.target.checked==true? param.allDeals =1 :param.allDeals =0 ) }}/>
                                            <span className="slider round text-left white pm pts hide">Yes</span>
                                            <span className="slider round text-right white pm pts sliderOff" >No</span></label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="box-footer mb mr">
                    <button className="icon-btn edit btn-sm pull-right" onClick={ () => moveTo(1)}><i className="fa fa-save"></i> Move</button>
                    <button className="icon-btn delete btn-sm pull-right" onClick={toggleDrawer}><i className="fa fa-close"></i> Close</button>

                </div>
            </div>
            
        </Drawer>
        </>
    )
}